import { useMemo } from 'react';
import { requestsColumns } from '../config';
import { RequestsFilter, useRequests, useRequestsPagination } from '../hooks';
import { Table, GlobalButton, Authorize } from '@/components';
import { useNavigate } from 'react-router-dom';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useSortableData } from '@/hooks';
import { Edit as EditIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { ROLES } from '@/components/security/AppRoles';

interface RequestsTableProps {
  filter: RequestsFilter;
}

const RequestsTable = ({ filter }: RequestsTableProps) => {
  const navigate = useNavigate();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useRequestsPagination();

  const { requests, totalItems, totalPages, isLoading } = useRequests({
    paginated: {
      page: currentPage,
      pageSize: pageSize,
    },
    userId: filter.userId?.[0] || '',
    statuses: filter.statuses,
    assetTypeId: filter.assetTypeId,
  });

  const columns = useMemo(() => requestsColumns, []);

  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: requests,
    currentPage: currentPage,
  });

  const renderActions = (rowData: Record<string, any>) => (
    <div className='flex justify-end gap-2'>
      <Authorize permission={ROLES.INVENTORY.admin}>
        <div className='rounded-full overflow-hidden'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate(`/inventory/requests/${rowData.id}/manage`)}
          >
            Gestionar
          </GlobalButton>
        </div>
      </Authorize>
      <IconButton
        onClick={() => navigate(`/inventory/requests/${rowData.id}/edit`)}
      >
        <EditIcon />
      </IconButton>
    </div>
  );

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5'>
      {sortedData?.length > 0 ? (
        <Table
          data={sortedData}
          renderActions={renderActions}
          columns={columns}
          selectedSort={selectedSort}
          handleSort={handleSort}
          isLoading={isLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        ></Table>
      ) : (
        'No hay ninguna petición por el momento'
      )}
    </div>
  );
};

export default RequestsTable;
